import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { EventFeedback, FeedbackFormQuestion, EventFeedbackAnonymousView } from 'cb-model';
import {
  Display,
  PageTitle,
  QuerySingle,
  Section,
  selectUser,
  useCacheQuery,
  useCacheRecord,
} from 'gossamer-front-end';
import { getFilter } from 'gossamer-unified';

export const EventFeedbackDisplay = (): React.JSX.Element => {
  const params = useParams();
  const user = useSelector(selectUser);
  const FeedbackEntity = user.roleId === 'user' ? EventFeedbackAnonymousView : EventFeedback;
  const eventFeedback = useCacheRecord(FeedbackEntity, params.key, !user);
  const formQuestions = useCacheQuery(
    FeedbackFormQuestion,
    {
      where: {
        and: [getFilter('feedback_form_id', 'eq', eventFeedback.data?.feedback_form_id)],
      },
    },
    typeof eventFeedback.data?.feedback_form_id !== 'number',
  );
  const rawData: Record<string, string> = (eventFeedback.data?.responses as Record<string, string>) || {};
  const localQuestions = !!formQuestions.data ? formQuestions.data.slice() : [];
  const rows = !!formQuestions.data
    ? localQuestions
        .sort((a, b) => a.seq - b.seq)
        .map((question) => (
          <tr key={question.id}>
            <td>
              <b>{question.title}:</b>
            </td>
            <td>{rawData['q' + question.id] ?? '-'}</td>
          </tr>
        ))
    : Object.keys(rawData).map((key) => (
        <tr key={key}>
          <td>
            <b>{key}:</b>
          </td>
          <td>{rawData[key]}</td>
        </tr>
      ));
  return (
    <>
      <PageTitle title="Display this Event Feedback" subtitle="Details relating to Feedback provided about an event" />
      <Section>
        <QuerySingle entity={FeedbackEntity} keyValue={params.key} render={Display} />
      </Section>
      <Section title="Full Responses">
        <table cellPadding={2}>
          <tbody>{rows}</tbody>
        </table>
      </Section>
    </>
  );
};
